import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { EventTypes } from 'src/app/core/constants/event-types';
import { IpDisplayerPipe } from 'src/app/core/pipes/ip-displayer.pipe';
import {
  ActiveSessionsDto,
  CustomResultOfListOfActiveSessionsDto,
  Device,
} from './../../../../core/api/models';
import { AccountService } from './../../../../core/api/services';
import { BaseIndexPageComponent } from './../../../../pages/shared/base/components/base-index-page.component';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';


@Component({
    selector: 'app-active-sessions',
    templateUrl: './active-sessions.component.html',
    styleUrls: ['./active-sessions.component.scss'],
    providers: [IpDisplayerPipe],
    imports: [BaseIndexModule]
})
export class ActiveSessionsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'activeSessions';
  idPropertyName = 'sessionId';
  items: Array<ActiveSessionsDto> = [];

  preloadingRowCount = [...Array(3).keys()];
  preloadingColCount = [...Array(6).keys()];
  appLang: string = 'fa';
  isShowError: boolean = false;

  get Device() {
    return Device;
  }

  //#endregion

  constructor(
    protected currentService: AccountService,
    private IpDisplayerPipe: IpDisplayerPipe
  ) {
    super();
  }

  ngOnInit() {
    this.getVocabs();
    this.configPage();
    this.getTableData();
    this.setDefaultTableSort();
  }

  getTableData() {
    this.unSubs();

    this.items = [];
    this.pageConfig.loading = true;
    this.pageConfig.isEmpty = false;
    this.isShowError = false;

    this.getUserActiveSessionsApi()
      .pipe(
        this.basePipeOperators(),
        tap((items) => {
          if (!items.data?.length) this.pageConfig.isEmpty = true;
        })
      )
      .subscribe(
        (items) => {
          this.items = items.data;
        },
        (error) => {
          this.isShowError = true;
        }
      );
  }

  configTableColumns(): void {}

  //#region Api
  getPaginationApi(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  getUserActiveSessionsApi(): Observable<CustomResultOfListOfActiveSessionsDto> {
    return this.currentService.accountActiveSessions();
  }

  baseDeleteApi(sessionId?: string) {
    this.unSubs();
    this.pageConfig.loading = true;
    this.lastSelectedItemId = sessionId;

    this.currentService
      .accountRemoveSession({ body: { sessionId: sessionId } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //#endregion

  onRefresh() {
    this.getTableData();
  }

  onDelete(id, content) {
    try {
      content = this.IpDisplayerPipe.transform(content);
      super.onDelete(id, content);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
}
